import { TableCell, TableRow } from "@mui/material";
import { useTranslation } from "react-i18next";
import { TablePaginationProps } from "../../../common/components/functional/pagination/types";
import { StripedTable } from "../../../common/components/functional/stripedTable/StripedTable";
import { StripedTableHeader } from "../../../common/components/functional/stripedTable/types";
import { TalentExclusivity } from "../../talents/talentAPI";
import ExclusivityRow from "./ExclusivityRow";

type Props = {
  exclusivities: TalentExclusivity[];
  onEditClick: (entry: TalentExclusivity) => void;
  onDeleteClick: (entryId: string, version: number) => void;
  pagination?: TablePaginationProps;
  isLoading?: boolean;
  isCollapsed?: boolean;
  onToggleCollapse?: () => void;
};

const ExclusivityTable = ({
  exclusivities,
  onEditClick,
  onDeleteClick,
  pagination,
  isCollapsed,
  onToggleCollapse,
}: Props) => {
  const { t } = useTranslation();

  const HEADERS: StripedTableHeader[] = [
    { key: "customerCompany", label: t("customerCompany"), width: "15%" },
    { key: "organization", label: t("talentProfile:organization"), width: "15%" },
    { key: "workLocation", label: t("workLocation"), width: "15%" },
    { key: "workTitles", label: t("workTitles"), width: "15%" },
    { key: "createdAt", label: t("talentProfile:createdAt"), width: "5%" },
    { key: "spacerBlacklister", label: "", width: "5%" },
    { key: "spacerReason", label: "", width: "22%" },
    { key: "actions", label: "", width: "8%" },
  ];

  const emptyRow = [
    <TableRow key="empty">
      <TableCell colSpan={8}>{t("noItems")}</TableCell>
    </TableRow>,
  ];

  const exclusivityRows = exclusivities.map((entry) => (
    <ExclusivityRow
      key={entry.id}
      entry={entry}
      onEditClick={onEditClick}
      onDeleteClick={onDeleteClick}
    />
  ));

  const ROWS = exclusivities.length ? exclusivityRows : emptyRow;

  return (
    <StripedTable
      maxWidth="1800px"
      columnHeaders={HEADERS}
      itemRows={ROWS}
      pagination={pagination}
      isCollapsed={isCollapsed}
      onToggleCollapse={onToggleCollapse}
    />
  );
};

export default ExclusivityTable;
